import schoolStatsIcon from '@/assets/icons/schoolStats.svg';
import schoolStatsIconPending from '@/assets/icons/schoolStatsPending.svg';
import StatCard from '@/components/Views/StatCard/StatCard';
import { useGetVerifiedSchools } from '@/api/hooks/establishment';
import { useMemo } from 'react';

const EstablishmentStatistics = () => {
  const { data: establishments, isLoading } = useGetVerifiedSchools({});

  // Calcul des statistiques côté client
  const stats = useMemo(() => {
    if (!establishments) {
      return [
        {
          icon: schoolStatsIcon,
          title: 'Total Etablissements',
          value: 0,
        },
        {
          icon: schoolStatsIconPending,
          title: 'Etablissements en attente',
          value: 0,
        },
      ];
    }

    const totalEstablishments = establishments.length;
    const pendingEstablishments = establishments.filter(
      (establishment) => establishment.status === 'INACTIVE',
    ).length;

    return [
      {
        icon: schoolStatsIcon,
        title: 'Total Etablissements',
        value: totalEstablishments,
      },
      {
        icon: schoolStatsIconPending,
        title: 'Etablissements en attente',
        value: pendingEstablishments,
      },
    ];
  }, [establishments]);

  if (isLoading) {
    return (
      <div className="grid grid-cols-4 gap-4 mb-16">
        {[1, 2].map((index) => (
          <div key={index} className="animate-pulse">
            <div className="bg-gray-300 h-32 rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-4 gap-4 mb-16">
      {stats.map(({ icon, title, value }, index) => (
        <StatCard key={index} icon={icon} title={title} value={value || 0} />
      ))}
    </div>
  );
};

export default EstablishmentStatistics;
